/* istanbul ignore file */
export const SET_THEME = 'SET_THEME'

export const setTheme = theme => ({ type: SET_THEME, theme })
